import Svg, { Mask, Path, Rect } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const UndefinedSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3891" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3891)"
      />
      <Rect x={4} y={18} width={4} height={2} rx={1} fill="#E6E6E6" />
      <Rect x={10} y={18} width={4} height={2} rx={1} fill="#E6E6E6" />
      <Rect x={16} y={18} width={4} height={2} rx={1} fill="#E6E6E6" />
      <Rect x={22} y={18} width={4} height={2} rx={1} fill="#E6E6E6" />
      <Rect x={4} y={14} width={14} height={2} rx={1} fill="#E6E6E6" />
      <Rect x={4} y={8} width={6} height={4} rx={1} fill="#E6E6E6" />
    </Svg>
  )
}
